export default __webpack_public_path__ + "static/media/laptop-full-pariuriplus.c26660d9.png";